import {map} from 'lodash';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {SelectFormik, SelectProps} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {buildTranslationKey} from 'utils/transform';

const T_KEYS = TRANSLATION_KEYS.COMMON.AI_PROVIDER;

type Props = {
    name: string;
    // Always supplied by the backend: it knows which providers support the purpose and which are enabled for the
    // account, so the list is never rebuilt from a client-side copy of the capability map.
    providers: string[];
    className?: string;
} & Partial<SelectProps>;

// Offers "None" by default: for purposes without their own toggle (compliance, translation) an empty provider is
// what turns the feature off — the runtime treats "no provider configured" as disabled.
export const AiProviderSelect: React.FC<Props> = ({name, providers = [], className, noneOption = true, ...rest}) => {
    const {t} = useTranslation();

    const options = useMemo(() => map(providers, (provider) => ({
        id: provider,
        name: t(T_KEYS[buildTranslationKey(provider)])
    })), [t, providers]);

    return (
        <SelectFormik
            {...rest}
            name={name}
            options={options}
            valueAs='id'
            noneOption={noneOption}
            className={className}
        />
    );
};
